// Module-level snapshot of the active identity so non-React code (the S3
// helpers, toy packaging) can resolve who we're acting as without threading the
// id through every call. The ImpersonationProvider keeps this in sync on render.

type CurrentIdentitySnapshot = {
  // Who the app reads/writes as: the impersonated user when an admin is
  // impersonating, otherwise the logged-in user's own Cognito identityId.
  currentIdentityId: string | null
  // The logged-in operator's own identityId, regardless of impersonation.
  impersonatorIdentityId: string | null
}

let snapshot: CurrentIdentitySnapshot = {
  currentIdentityId: null,
  impersonatorIdentityId: null,
}

export function setCurrentIdentitySnapshot(next: CurrentIdentitySnapshot): void {
  snapshot = next
}

// Normal usage: the identityId the app should act as. Mirrors getIdentityId's
// contract of failing loudly when there is no identity available.
export function getCurrentIdentityId(): string {
  const id = snapshot.currentIdentityId
  if (!id) throw new Error('No current identity: not authenticated')
  return id
}

// The real operator's identityId, for the rare case we explicitly want the
// admin behind an impersonation session (audit/log, attribution checks).
export function getImpersonatorIdentityId(): string {
  const id = snapshot.impersonatorIdentityId
  if (!id) throw new Error('No current identity: not authenticated')
  return id
}
